var Y = Object.defineProperty, Z = Object.defineProperties;
var z = Object.getOwnPropertyDescriptors;
var R = Object.getOwnPropertySymbols;
var U = Object.prototype.hasOwnProperty, W = Object.prototype.propertyIsEnumerable;
var F = (o, r, t) => r in o ? Y(o, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : o[r] = t, c = (o, r) => {
  for (var t in r || (r = {}))
    U.call(r, t) && F(o, t, r[t]);
  if (R)
    for (var t of R(r))
      W.call(r, t) && F(o, t, r[t]);
  return o;
}, d = (o, r) => Z(o, z(r));
var N = (o, r) => {
  var t = {};
  for (var n in o)
    U.call(o, n) && r.indexOf(n) < 0 && (t[n] = o[n]);
  if (o != null && R)
    for (var n of R(o))
      r.indexOf(n) < 0 && W.call(o, n) && (t[n] = o[n]);
  return t;
};
import { jsx as p, jsxs as D } from "react/jsx-runtime";
import { r as q } from "./rem-CMQJ_ZTp.js";
import "react";
import { e as A, a as x, c as C } from "./get-size-Bc1Pz5yf.js";
import { c as _ } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as E, u as y, B as v } from "./factory-ueRxoNOV.js";
import { u as $ } from "./use-styles-DToiHEa6.js";
import { p as oo } from "./polymorphic-factory-DufevJAl.js";
import { L as to } from "./Loader-DVuQGvNU.js";
import { T as ro } from "./Transition-esp-rpzm.js";
import { U as no } from "./UnstyledButton-D9OCzDhz.js";
var h = { root: "m_77c9d27d", inner: "m_80f1301b", label: "m_811560b9", section: "m_a74036a", loader: "m_a25b86ee", group: "m_80d6d844", groupSection: "m_70be2a01" };
const O = {
  orientation: "horizontal"
}, eo = _((o, { borderWidth: r }) => ({
  group: { "--button-border-width": q(r) }
})), j = E((o, r) => {
  const t = y("ButtonGroup", O, o), b = y("ButtonGroup", O, o), {
    className: n,
    style: e,
    classNames: s,
    styles: a,
    unstyled: i,
    orientation: l,
    vars: m,
    borderWidth: f,
    variant: S,
    mod: B
  } = b, G = N(b, [
    "className",
    "style",
    "classNames",
    "styles",
    "unstyled",
    "orientation",
    "vars",
    "borderWidth",
    "variant",
    "mod"
  ]), u = $({
    name: "ButtonGroup",
    props: t,
    classes: h,
    className: n,
    style: e,
    classNames: s,
    styles: a,
    unstyled: i,
    vars: m,
    varsResolver: eo,
    rootSelector: "group"
  });
  return /* @__PURE__ */ p(
    v,
    c(d(c({}, u("group")), {
      ref: r,
      variant: S,
      mod: [{ "data-orientation": l }, B],
      role: "group"
    }), G)
  );
});
j.classes = h;
j.displayName = "@mantine/core/ButtonGroup";
const V = {}, so = _(
  (o, { radius: r, color: t, gradient: n, variant: e, autoContrast: s, size: a }) => {
    const i = o.variantColorResolver({
      color: t || o.primaryColor,
      theme: o,
      gradient: n,
      variant: e || "filled",
      autoContrast: s
    });
    return {
      groupSection: {
        "--section-height": C(a, "section-height"),
        "--section-padding-x": C(a, "section-padding-x"),
        "--section-fz": a != null && a.includes("compact") ? x(a.replace("compact-", "")) : x(a),
        "--section-radius": r === void 0 ? void 0 : A(r),
        "--section-bg": t || e ? i.background : void 0,
        "--section-color": i.color,
        "--section-bd": t || e ? i.border : void 0
      }
    };
  }
), k = E((o, r) => {
  const t = y("ButtonGroupSection", V, o), b = y("ButtonGroupSection", V, o), {
    className: n,
    style: e,
    classNames: s,
    styles: a,
    unstyled: i,
    vars: l,
    variant: m,
    gradient: f,
    radius: S,
    autoContrast: B
  } = b, G = N(b, [
    "className",
    "style",
    "classNames",
    "styles",
    "unstyled",
    "vars",
    "variant",
    "gradient",
    "radius",
    "autoContrast"
  ]), u = $({
    name: "ButtonGroupSection",
    props: t,
    classes: h,
    className: n,
    style: e,
    classNames: s,
    styles: a,
    unstyled: i,
    vars: l,
    varsResolver: so,
    rootSelector: "groupSection"
  });
  return /* @__PURE__ */ p(v, c(d(c({}, u("groupSection")), { ref: r, variant: m }), G));
});
k.classes = h;
k.displayName = "@mantine/core/ButtonGroupSection";
const ao = {
  in: { opacity: 1, transform: `translate(-50%, calc(-50% + ${q(1)}))` },
  out: { opacity: 0, transform: "translate(-50%, -200%)" },
  common: { transformOrigin: "center" },
  transitionProperty: "transform, opacity"
}, io = {}, co = _(
  (o, { radius: r, color: t, gradient: n, variant: e, size: s, justify: a, autoContrast: i }) => {
    const l = o.variantColorResolver({
      color: t || o.primaryColor,
      theme: o,
      gradient: n,
      variant: e || "filled",
      autoContrast: i
    });
    return {
      root: {
        "--button-justify": a,
        "--button-height": C(s, "button-height"),
        "--button-padding-x": C(s, "button-padding-x"),
        "--button-fz": s != null && s.includes("compact") ? x(s.replace("compact-", "")) : x(s),
        "--button-radius": r === void 0 ? void 0 : A(r),
        "--button-bg": t || e ? l.background : void 0,
        "--button-hover": t || e ? l.hover : void 0,
        "--button-color": l.color,
        "--button-bd": t || e ? l.border : void 0,
        "--button-hover-color": t || e ? l.hoverColor : void 0
      }
    };
  }
), P = oo((o, r) => {
  const t = y("Button", io, o), T = t, {
    style: n,
    vars: e,
    className: s,
    color: a,
    disabled: i,
    children: l,
    leftSection: m,
    rightSection: f,
    fullWidth: S,
    variant: B,
    radius: G,
    loading: u,
    loaderProps: b,
    gradient: lo,
    classNames: H,
    styles: I,
    unstyled: w,
    "data-disabled": L,
    autoContrast: uo,
    mod: J
  } = T, K = N(T, [
    "style",
    "vars",
    "className",
    "color",
    "disabled",
    "children",
    "leftSection",
    "rightSection",
    "fullWidth",
    "variant",
    "radius",
    "loading",
    "loaderProps",
    "gradient",
    "classNames",
    "styles",
    "unstyled",
    "data-disabled",
    "autoContrast",
    "mod"
  ]), g = $({
    name: "Button",
    props: t,
    classes: h,
    className: s,
    style: n,
    classNames: H,
    styles: I,
    unstyled: w,
    vars: e,
    varsResolver: co
  }), M = !!m, Q = !!f;
  return /* @__PURE__ */ D(
    no,
    d(c(d(c({
      ref: r
    }, g("root", { active: !i && !u && !L })), {
      unstyled: w,
      variant: B,
      disabled: i || u,
      mod: [
        {
          disabled: i || L,
          loading: u,
          block: S,
          "with-left-section": M,
          "with-right-section": Q
        },
        J
      ]
    }), K), {
      children: [
        /* @__PURE__ */ p(ro, { mounted: !!u, transition: ao, duration: 150, children: (X) => /* @__PURE__ */ p(v, d(c({ component: "span" }, g("loader", { style: X })), { "aria-hidden": !0, children: /* @__PURE__ */ p(
          to,
          c({
            color: "var(--button-color)",
            size: "calc(var(--button-height) / 1.8)"
          }, b)
        ) })) }),
        /* @__PURE__ */ D("span", d(c({}, g("inner")), { children: [
          m && /* @__PURE__ */ p(v, d(c({ component: "span" }, g("section")), { mod: { position: "left" }, children: m })),
          /* @__PURE__ */ p(v, d(c({ component: "span", mod: { loading: u } }, g("label")), { children: l })),
          f && /* @__PURE__ */ p(v, d(c({ component: "span" }, g("section")), { mod: { position: "right" }, children: f }))
        ] }))
      ]
    })
  );
});
P.classes = h;
P.displayName = "@mantine/core/Button";
P.Group = j;
P.GroupSection = k;
export {
  P as B
};
